import apiClient from '../http/apiClient';

export default class CustomerAPI {
    static postCustomer = (customer) =>
        apiClient.post('/customer', customer, {
            headers: {
                'Content-Type': 'multipart/form-data',
            },
        });

    static getCustomersByRole = (context = null, role = role) => apiClient.get('/customer', {params: {context, role}});

    static getCustomers = (context = null) => apiClient.get('/customer', {params: {context}});
}
